import { getSelectedRowIndexes } from './getSelectedRowIndexes';

// Absolute indexes of every selected row, virtual (unloaded) rows included.
// Select-all keeps unloaded rows as a count, so the full set is [0..totalCount)
// minus the loaded rows the user explicitly deselected.
export const getSelectedRowIndexesWithVirtual = (
  data: any[],
  selectedRows: any[],
  selectedVirtualRows: number
): number[] => {
  if (selectedVirtualRows <= 0)
    return getSelectedRowIndexes(data, selectedRows);

  const totalCount = data.length + selectedVirtualRows;
  const selected = new Set(selectedRows);
  const deselectedLoaded = new Set<number>();
  data.forEach((row, index) => {
    if (!selected.has(row)) deselectedLoaded.add(index);
  });

  const indexes: number[] = [];
  for (let index = 0; index < totalCount; index += 1) {
    if (!deselectedLoaded.has(index)) indexes.push(index);
  }
  return indexes;
};
